import { createUseStyles } from "react-jss";

const portal = "#222222";
const laser = "#FF3158";
const moonrock = "#F5F4F3";
interface ButtonProps {
  dark: boolean;
  light: boolean;
  thin: boolean;
}
// Need to declare props here to handle types
export const useButtonStyles = createUseStyles({
  buttonBase: {
    alignContent: "baseline",
    alignItems: "inherit",
    borderRadius: "6px",
    cursor: "pointer",
    flexDirection: "row",
    fontFamily: '"IBM Plex Sans","Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize: "16px",
    fontWeight: 700,
    height: ({ thin }: ButtonProps) => (thin ? "34px" : "48px"),
    justifyContent: "center",
    letterSpacing: "0.2px",
    lineHeight: "16px",
    minHeight: "34px",
    minWidth: "100px",
    outline: 0,
    padding: ({ thin }: ButtonProps) => (thin ? "0 10px" : "10px"),
    textAlign: "center",
    textDecoration: "none",
    textTransform: "none",
    transition: "all 250ms ease-out",
    width: "auto",
    "&:focus-visible": {
      outline: "1px auto Highlight",
    },
  },
  buttonPrimary: {
    borderColor: "transparent",
    "&:disabled": {
      cursor: "inherit",
      opacity: 0.3,
    },
    "&:hover:not([disabled])": {
      backgroundColor: laser,
      borderColor: "transparent",
      color: moonrock,
    },
    [`@media (prefers-color-scheme: light)`]: {
      backgroundColor: ({ light }: ButtonProps) => (light ? moonrock : portal),
      color: ({ light }: ButtonProps) => (light ? portal : moonrock),
    },
    [`@media (prefers-color-scheme: dark)`]: {
      backgroundColor: ({ dark }: ButtonProps) => (dark ? portal : moonrock),
      color: ({ dark }: ButtonProps) => (dark ? moonrock : portal),
    },
  },
  buttonSecondary: {
    backgroundColor: "transparent",
    "&:disabled": {
      cursor: "inherit",
      opacity: 0.3,
    },
    "&:hover:not([disabled])": {
      borderColor: laser,
      color: laser,
    },
    [`@media (prefers-color-scheme: light)`]: {
      color: ({ light }: ButtonProps) => (light ? moonrock : portal),
      border: ({ light }: ButtonProps) =>
        light ? `2px solid ${moonrock}` : `2px solid ${portal}`,
    },
    [`@media (prefers-color-scheme: dark)`]: {
      color: ({ dark }: ButtonProps) => (dark ? portal : moonrock),
      border: ({ dark }: ButtonProps) =>
        dark ? `2px solid ${portal}` : `2px solid ${moonrock}`,
    },
  },
  buttonTertiary: {
    background: "none",
    border: "none",
    fontFamily: '"Roboto","Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize: 14,
    letterSpacing: "0.6px",
    lineHeight: "26px",
    minHeight: "auto",
    minWidth: "auto",
    padding: 0,
    textTransform: "none",
    width: "auto",
    "&:hover:not([disabled])": {
      color: laser,
      "& span": {
        borderBottomColor: laser,
      },
    },
    "& span": {
      transition: "border 250ms ease-out",
    },
    [`@media (prefers-color-scheme: light)`]: {
      color: ({ light }: ButtonProps) => (light ? moonrock : portal),
      "& span": {
        borderBottom: ({ light }: ButtonProps) =>
          light ? `2px solid ${moonrock}` : `2px solid ${portal}`,
      },
      "&:disabled": {
        cursor: "inherit",
        opacity: 0.3,
        "& span": {
          opacity: 0.3,
        },
      },
    },
    [`@media (prefers-color-scheme: dark)`]: {
      color: ({ dark }: ButtonProps) => (dark ? portal : moonrock),
      "& span": {
        borderBottom: ({ dark }: ButtonProps) =>
          dark ? `2px solid ${portal}` : `2px solid ${moonrock}`,
      },
      "&:disabled": {
        opacity: 0.3,
        cursor: "inherit",
        "& span": {
          opacity: 0.3,
        },
      },
    },
  },
  buttonLink: {
    padding: "0 !important",
    height: "auto !important",
    minHeight: 0,
    minWidth: 0,
    backgroundColor: "transparent",
    borderColor: "transparent",
    "&:disabled": {
      cursor: "inherit",
      opacity: 0.3,
    },
    "&:hover:not([disabled])": {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: laser,
      "&:myIcon": {
        fill: laser,
      },
    },
  },
  myLabel: {
    "font-weight": "bold",
    "align-items": "center",
    display: "inline-flex",
  },
  myIcon: {
    "margin-right": "12px",
  },
});
